import { render, staticRenderFns } from "./renewal-preview-form.component.vue?vue&type=template&id=0c46f6da&"
import script from "./renewal-preview-form.component.ts?vue&type=script&lang=ts&"
export * from "./renewal-preview-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./renewal-preview-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports